// Build target: development (Azure web app -d01).
// All values are hydrated at runtime by `/api/config` (see server.js), which
// reads the Azure App Settings configured in the corresponding web app.
export const environment = {
  apim: {
    baseUrl: ''
  },
  paths: {
    whatsapp: '',
    whatsappWs: '',
    common: ''
  },
  msal: {
    clientId: '',
    authority: '',
    knownAuthorities: [] as string[],
    redirectPath: '/auth/callback',
    postLogoutRedirectPath: '/login',
    loginScopes: ['openid', 'offline_access'],
    apiScopes: [] as string[]
  }
};
